// import React, { useEffect, useState } from 'react'
// import apiCall from '../helper/apiCall';
// import ImageCarouselModal from './ImageCarouselModal';

// const ProductVariantsModal = ({ show, onClose, product, onSave }) => {
//     const [variants, setVariants] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [isSaving, setIsSaving] = useState(false);
//     const [productStatus, setProductStatus] = useState(false);
//     const [showCarousel, setShowCarousel] = useState(false);
//     const [carouselImages, setCarouselImages] = useState([]);
//     const [errors, setErrors] = useState({});
//    //console.log('productStatus:',product.status);
//     // Fetch product variants when the modal opens or product changes
//     useEffect(() => {
//         if (show && product) {
//             setProductStatus(product.status === 'Active');
//             setLoading(true);
//             setErrors({}); // Clear errors when modal opens
//             const fetchVariants = async () => {
//                 const response = await apiCall("getProductDetails", { product_id: product.product_id });
//                 if (response.success) {
//                     setVariants(response.data);
//                 }
//                 setLoading(false);
//             };
//             fetchVariants();
//         }
//     }, [show, product]);
    
//     // Function to perform validation on the entire variants array
//     const validateVariants = (variantsToValidate) => {
//         const newErrors = {};
//         variantsToValidate.forEach(variant => {
//             const mrp = parseFloat(variant.product_item_mrp);
//             const sellPrice = parseFloat(variant.product_item_sell_price);

//             if (sellPrice > mrp) {
//                 newErrors[variant.product_item_id] = {
//                     sell_price: 'Selling Price cannot be greater than MRP.'
//                 };
//             }
//         });
//         return newErrors;
//     };

//     const handleVariantChange = (id, field, value) => {
//         // Create an updated copy of the variants array
//         const updatedVariants = variants.map(v => v.product_item_id === id ? { ...v, [field]: value } : v);
//         setVariants(updatedVariants);

//         // Run validation in real-time
//         const newErrors = validateVariants(updatedVariants);
//         setErrors(newErrors);
//     };

//     const handleSave = async () => {
//         // Run a final validation check before saving
//         const newErrors = validateVariants(variants);
//         setErrors(newErrors);

//         if (Object.keys(newErrors).length > 0) {
//             return; // Stop if there are validation errors
//         }

//         setIsSaving(true);
//         const response = await apiCall("updateProduct", {
//             productId: product.product_id,
//             variants: variants,
//             status: productStatus ? 'Active' : 'Inactive',
//         });

//         if (response.success) {
//             onSave(response.message);
//         } else {
//             // Handle error, maybe show an error message
//             onSave('Failed to save changes.', true);
//         }
//         setIsSaving(false);
//         onClose();
//     };

//     const handleImageClick = (images) => {
//         if (images && images.length > 0) {
//             setCarouselImages(images);
//             setShowCarousel(true);
//         }
//     };

//     if (!show) {
//         return null;
//     }

//     const hasValidationErrors = Object.keys(errors).length > 0;

//     return (
//         <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex justify-center items-center z-50 transition-opacity duration-300">
//             <div className="relative bg-white p-8 rounded-lg shadow-xl w-11/12 max-w-4xl max-h-[90vh] overflow-y-auto transform scale-95 transition-transform duration-300" onClick={e => e.stopPropagation()}>
//                 <div className="flex justify-between items-center pb-4 mb-4 border-b border-gray-200">
//                     <h2 className="text-2xl font-semibold text-gray-800">Manage Variants for {product.product_name}</h2>
//                     <button className="text-gray-400 hover:text-gray-600 text-3xl leading-none font-semibold transition-colors duration-200" onClick={onClose}>
//                         &times;
//                     </button>
//                 </div>
                
//                 {loading ? (
//                     <div className="text-center py-8">Loading variants...</div>
//                 ) : (
//                     <div className="space-y-6">
//                         <div className="flex items-center space-x-4">
//                             <span className="text-sm font-medium text-gray-700">Product Status:</span>
//                             <label className="relative inline-flex items-center cursor-pointer">
//                                 <input
//                                     type="checkbox"
//                                     checked={productStatus}
//                                     onChange={(e) => setProductStatus(e.target.checked)}
//                                     className="sr-only peer"
//                                 />
//                                 <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
//                                 <span className="ml-3 text-sm font-medium text-gray-900">{productStatus ? 'Active' : 'Inactive'}</span>
//                             </label>
//                         </div>
//                         {variants.length > 0 ? (
//                             <table className="min-w-full divide-y divide-gray-200 rounded-lg overflow-hidden border border-gray-200 shadow-sm">
//                                 <thead className="bg-gray-50">
//                                     <tr>
//                                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Image</th>
//                                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">SKU</th>
//                                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Attributes</th>
//                                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Stock Qty</th>
//                                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">MRP</th>
//                                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sell Price</th>
//                                     </tr>
//                                 </thead>
//                                 <tbody className="bg-white divide-y divide-gray-200">
//                                     {variants.map(variant => (
//                                         <tr key={variant.product_item_id} className="hover:bg-gray-50">
//                                             <td className="px-6 py-4 whitespace-nowrap cursor-pointer" onClick={() => handleImageClick(variant.product_item_images)}>
//                                                 {variant.product_item_images && variant.product_item_images.length > 0 && (
//                                                     <img src={variant.product_item_images[0]} alt={`Variant ${variant.product_item_id}`} className="h-12 w-12 rounded-md object-cover" />
//                                                 )}
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{variant.product_item_id}</td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                                                 {variant.size_name && `Size: ${variant.size_name}`}
//                                                 {variant.size_name && variant.color_name && " | "}
//                                                 {variant.color_name && `Color: ${variant.color_name}`}
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                                                 <input
//                                                     type="number"
//                                                     value={variant.product_item_stock_qty}
//                                                     onChange={(e) => handleVariantChange(variant.product_item_id, 'product_item_stock_qty', e.target.value)}
//                                                     className="w-20 rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500"
//                                                 />
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                                                 <input
//                                                     type="number"
//                                                     value={variant.product_item_mrp}
//                                                     onChange={(e) => handleVariantChange(variant.product_item_id, 'product_item_mrp', e.target.value)}
//                                                     className="w-20 rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500"
//                                                 />
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                                                 <input
//                                                     type="number"
//                                                     value={variant.product_item_sell_price}
//                                                     onChange={(e) => handleVariantChange(variant.product_item_id, 'product_item_sell_price', e.target.value)}
//                                                     className="w-20 rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500"
//                                                 />
//                                                 {errors[variant.product_item_id]?.sell_price && (
//                                                     <p className="text-red-500 text-xs mt-1">{errors[variant.product_item_id].sell_price}</p>
//                                                 )}
//                                             </td>
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         ) : (
//                             <div className="text-center py-8 text-gray-500">No variants found for this product.</div>
//                         )}
                        
//                         <div className="flex justify-end pt-4 border-t border-gray-200">
//                             <button
//                                 onClick={handleSave}
//                                 disabled={isSaving || hasValidationErrors}
//                                 className={`px-6 py-2 rounded-lg text-white font-semibold transition-colors duration-200 ${isSaving || hasValidationErrors ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
//                             >
//                                 {isSaving ? 'Saving...' : 'Save Changes'}
//                             </button>
//                         </div>
//                     </div>
//                 )}
//             </div>
            
//             <ImageCarouselModal show={showCarousel} onClose={() => setShowCarousel(false)} images={carouselImages} />
//         </div>
//     );
// };


// export default ProductVariantsModal

// import React, { useEffect, useState } from 'react'
// import apiCall from '../helper/apiCall';
// import ImageCarouselModal from './ImageCarouselModal';
// import BarcodeGenerator from './BarcodeGenerator'; // <<< 1. IMPORT THE NEW COMPONENT

// const ProductVariantsModal = ({ show, onClose, product, onSave }) => {
//     const [variants, setVariants] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [isSaving, setIsSaving] = useState(false);
//     const [productStatus, setProductStatus] = useState(false);
//     const [showCarousel, setShowCarousel] = useState(false);
//     const [carouselImages, setCarouselImages] = useState([]);
//     const [errors, setErrors] = useState({});

//     // Fetch product variants when the modal opens or product changes
//     useEffect(() => {
//         if (show && product) {
//             setProductStatus(product.status === 'Active');
//             setLoading(true);
//             setErrors({}); // Clear errors when modal opens
//             const fetchVariants = async () => {
//                 const response = await apiCall("getProductDetails", { product_id: product.product_id });
//                 if (response.success) {
//                     // Assuming 'barcode_number' is present in the response data structure
//                     setVariants(response.data);
//                 }
//                 setLoading(false);
//             };
//             fetchVariants();
//         }
//     }, [show, product]);
    
//     // Function to perform validation on the entire variants array
//     const validateVariants = (variantsToValidate) => {
//         const newErrors = {};
//         variantsToValidate.forEach(variant => {
//             const mrp = parseFloat(variant.product_item_mrp);
//             const sellPrice = parseFloat(variant.product_item_sell_price);

//             if (sellPrice > mrp) {
//                 newErrors[variant.product_item_id] = {
//                     sell_price: 'Selling Price cannot be greater than MRP.'
//                 };
//             }
//         });
//         return newErrors;
//     };

//     const handleVariantChange = (id, field, value) => {
//         // Create an updated copy of the variants array
//         const updatedVariants = variants.map(v => v.product_item_id === id ? { ...v, [field]: value } : v);
//         setVariants(updatedVariants);

//         // Run validation in real-time
//         const newErrors = validateVariants(updatedVariants);
//         setErrors(newErrors);
//     };

//     const handleSave = async () => {
//         // Run a final validation check before saving
//         const newErrors = validateVariants(variants);
//         setErrors(newErrors);

//         if (Object.keys(newErrors).length > 0) {
//             return; // Stop if there are validation errors
//         }

//         setIsSaving(true);
//         const response = await apiCall("updateProduct", {
//             productId: product.product_id,
//             variants: variants,
//             status: productStatus ? 'Active' : 'Inactive',
//         });

//         if (response.success) {
//             onSave(response.message);
//         } else {
//             // Handle error, maybe show an error message
//             onSave('Failed to save changes.', true);
//         }
//         setIsSaving(false);
//         onClose();
//     };

//     const handleImageClick = (images) => {
//         if (images && images.length > 0) {
//             setCarouselImages(images);
//             setShowCarousel(true);
//         }
//     };
    
//     // <<< 2. NEW FUNCTION TO PRINT A SINGLE BARCODE
//     const handlePrintBarcode = (variantId) => {
//         // Select the specific variant's print area container
//         const printArea = document.getElementById(`barcode-print-${variantId}`);
//         if (!printArea) return;

//         // Open a new window for printing
//         const printWindow = window.open('', '_blank');
//         if (!printWindow) return; // Handle popup blocker

//         // Construct the content to print
//         const content = printArea.innerHTML;
        
//         // Write the HTML content to the new window
//         printWindow.document.write('<html><head><title>Barcode Print</title>');
//         // Optional: Include any necessary print-specific styles here
//         printWindow.document.write('<style>');
//         printWindow.document.write(`
//             @page { margin: 5mm; }
//             body { font-family: sans-serif; display: flex; flex-direction: column; align-items: flex-start; }
//             .barcode-container { margin-bottom: 5mm; }
//             .barcode-container svg { height: 40px !important; width: auto !important; }
//             .barcode-container text { font-size: 10px !important; }
//         `);
//         printWindow.document.write('</style></head><body>');
//         printWindow.document.write('<div class="barcode-container">' + content + '</div>');
//         printWindow.document.write('</body></html>');
        
//         printWindow.document.close();
//         printWindow.focus();
        
//         // Give the browser a moment to load everything, then print
//         setTimeout(() => {
//             printWindow.print();
//             printWindow.close();
//         }, 500);
//     };
//     // >>> END NEW FUNCTION

//     if (!show) {
//         return null;
//     }

//     const hasValidationErrors = Object.keys(errors).length > 0;

//     return (
//         <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex justify-center items-center z-50 transition-opacity duration-300">
//             <div className="relative bg-white p-8 rounded-lg shadow-xl w-11/12 max-w-6xl max-h-[90vh] overflow-y-auto transform scale-95 transition-transform duration-300" onClick={e => e.stopPropagation()}>
//                 <div className="flex justify-between items-center pb-4 mb-4 border-b border-gray-200">
//                     <h2 className="text-2xl font-semibold text-gray-800">Manage Variants for {product.product_name}</h2>
//                     <button className="text-gray-400 hover:text-gray-600 text-3xl leading-none font-semibold transition-colors duration-200" onClick={onClose}>
//                         &times;
//                     </button>
//                 </div>
                
//                 {loading ? (
//                     <div className="text-center py-8">Loading variants...</div>
//                 ) : (
//                     <div className="space-y-6">
//                         <div className="flex items-center space-x-4">
//                             <span className="text-sm font-medium text-gray-700">Product Status:</span>
//                             <label className="relative inline-flex items-center cursor-pointer">
//                                 <input
//                                     type="checkbox"
//                                     checked={productStatus}
//                                     onChange={(e) => setProductStatus(e.target.checked)}
//                                     className="sr-only peer"
//                                 />
//                                 <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
//                                 <span className="ml-3 text-sm font-medium text-gray-900">{productStatus ? 'Active' : 'Inactive'}</span>
//                             </label>
//                         </div>
//                         {variants.length > 0 ? (
//                             <table className="min-w-full divide-y divide-gray-200 rounded-lg overflow-hidden border border-gray-200 shadow-sm">
//                                 <thead className="bg-gray-50">
//                                     <tr>
//                                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Image</th>
//                                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">SKU</th>
//                                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Attributes</th>
//                                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Stock Qty</th>
//                                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">MRP</th>
//                                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sell Price</th>
//                                         <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Barcode & Print</th> {/* <<< NEW COLUMN */}
//                                     </tr>
//                                 </thead>
//                                 <tbody className="bg-white divide-y divide-gray-200">
//                                     {variants.map(variant => (
//                                         <tr key={variant.product_item_id} className="hover:bg-gray-50">
//                                             <td className="px-6 py-4 whitespace-nowrap cursor-pointer" onClick={() => handleImageClick(variant.product_item_images)}>
//                                                 {variant.product_item_images && variant.product_item_images.length > 0 && (
//                                                     <img src={variant.product_item_images[0]} alt={`Variant ${variant.product_item_id}`} className="h-12 w-12 rounded-md object-cover" />
//                                                 )}
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{variant.product_item_id}</td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                                                 {variant.size_name && `Size: ${variant.size_name}`}
//                                                 {variant.size_name && variant.color_name && " | "}
//                                                 {variant.color_name && `Color: ${variant.color_name}`}
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                                                 <input
//                                                     type="number"
//                                                     value={variant.product_item_stock_qty}
//                                                     onChange={(e) => handleVariantChange(variant.product_item_id, 'product_item_stock_qty', e.target.value)}
//                                                     className="w-20 rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500"
//                                                 />
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                                                 <input
//                                                     type="number"
//                                                     value={variant.product_item_mrp}
//                                                     onChange={(e) => handleVariantChange(variant.product_item_id, 'product_item_mrp', e.target.value)}
//                                                     className="w-20 rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500"
//                                                 />
//                                             </td>
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                                                 <input
//                                                     type="number"
//                                                     value={variant.product_item_sell_price}
//                                                     onChange={(e) => handleVariantChange(variant.product_item_id, 'product_item_sell_price', e.target.value)}
//                                                     className={`w-20 rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 ${errors[variant.product_item_id]?.sell_price ? 'border-red-500' : ''}`}
//                                                 />
//                                                 {errors[variant.product_item_id]?.sell_price && (
//                                                     <p className="text-red-500 text-xs mt-1">{errors[variant.product_item_id].sell_price}</p>
//                                                 )}
//                                             </td>
//                                             {/* <<< NEW BARCODE COLUMN */}
//                                             <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                                                 <div id={`barcode-print-${variant.product_item_id}`} className="mb-2">
//                                                     <BarcodeGenerator 
//                                                         data={variant.barcode_number} // Use the data prop
//                                                     />
//                                                 </div>
//                                                 {variant.barcode_number && (
//                                                     <button
//                                                         onClick={() => handlePrintBarcode(variant.product_item_id)}
//                                                         className="mt-1 px-3 py-1 text-xs font-medium text-white bg-green-500 rounded-md hover:bg-green-600 transition-colors duration-150"
//                                                     >
//                                                         Print Label
//                                                     </button>
//                                                 )}
//                                                 {!variant.barcode_number && (
//                                                     <span className="text-xs text-red-500 italic">Missing barcode data</span>
//                                                 )}
//                                             </td>
//                                             {/* >>> END NEW BARCODE COLUMN */}
//                                         </tr>
//                                     ))}
//                                 </tbody>
//                             </table>
//                         ) : (
//                             <div className="text-center py-8 text-gray-500">No variants found for this product.</div>
//                         )}
                        
//                         <div className="flex justify-end pt-4 border-t border-gray-200">
//                             <button
//                                 onClick={handleSave}
//                                 disabled={isSaving || hasValidationErrors}
//                                 className={`px-6 py-2 rounded-lg text-white font-semibold transition-colors duration-200 ${isSaving || hasValidationErrors ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
//                             >
//                                 {isSaving ? 'Saving...' : 'Save Changes'}
//                             </button>
//                         </div>
//                     </div>
//                 )}
//             </div>
            
//             <ImageCarouselModal show={showCarousel} onClose={() => setShowCarousel(false)} images={carouselImages} />
//         </div>
//     );
// };


// export default ProductVariantsModal

// ProductVariantsModal.jsx
import React, { useEffect, useState } from 'react';
// Assuming these are external helper/modal components you have
import apiCall from '../helper/apiCall'; 
import ImageCarouselModal from './ImageCarouselModal';
// The new component we created
import ProductLabel from './ProductLabel'; 

const ProductVariantsModal = ({ show, onClose, product, onSave }) => {
    const BASE_URL = "https://www.kanthasri.com"; // Replace with your actual domain
    const [variants, setVariants] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [productStatus, setProductStatus] = useState(false);
    const [showCarousel, setShowCarousel] = useState(false);
    const [carouselImages, setCarouselImages] = useState([]);
    const [errors, setErrors] = useState({});
    
    // Fetch product variants when the modal opens or product changes
    useEffect(() => {
        if (show && product) {
            setProductStatus(product.status === 'Active');
            setLoading(true);
            setErrors({}); // Clear errors when modal opens
            const fetchVariants = async () => {
                const response = await apiCall("getProductDetails", { product_id: product.product_id });
                if (response.success) {
                    setVariants(response.data);
                }
                setLoading(false);
            };
            fetchVariants();
        }
    }, [show, product]);
    
    // Function to perform validation on the entire variants array
    const validateVariants = (variantsToValidate) => {
        const newErrors = {};
        variantsToValidate.forEach(variant => {
            const mrp = parseFloat(variant.product_item_mrp);
            const sellPrice = parseFloat(variant.product_item_sell_price);

            if (sellPrice > mrp) {
                newErrors[variant.product_item_id] = {
                    sell_price: 'Selling Price cannot be greater than MRP.'
                };
            }
        });
        return newErrors;
    };

    const handleVariantChange = (id, field, value) => {
        // Create an updated copy of the variants array
        const updatedVariants = variants.map(v => v.product_item_id === id ? { ...v, [field]: value } : v);
        setVariants(updatedVariants);

        // Run validation in real-time
        const newErrors = validateVariants(updatedVariants);
        setErrors(newErrors);
    };

    const handleSave = async () => {
        // Run a final validation check before saving
        const newErrors = validateVariants(variants);
        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) {
            return; // Stop if there are validation errors
        }

        setIsSaving(true);
        const response = await apiCall("updateProduct", {
            productId: product.product_id,
            variants: variants,
            status: productStatus ? 'Active' : 'Inactive',
        });

        if (response.success) {
            onSave(response.message);
        } else {
            // Handle error, maybe show an error message
            onSave('Failed to save changes.', true);
        }
        setIsSaving(false);
        onClose();
    };

    const handleImageClick = (imageObjects) => {
    if (imageObjects && imageObjects.length > 0) {
        // Map the objects to an array of full URLs using the 'main' or 'zoom' key
        const imageUrls = imageObjects.map(img => `${BASE_URL}${img.main}`);
        setCarouselImages(imageUrls);
        setShowCarousel(true);
    }
};
    
    // FUNCTION TO PRINT THE ISOLATED BARCODE LABEL
    const handlePrintBarcode = (variant) => {
        // Select the specific variant's print area container by ID
        const printArea = document.getElementById(`barcode-print-container-${variant.product_item_id}`);
        if (!printArea) return;

        // Open a new window for printing
        const printWindow = window.open('', '_blank');
        if (!printWindow) return; // Handle popup blocker

        const content = printArea.innerHTML;
        
        printWindow.document.write('<html><head><title>Product Label Print</title>');
        
        // Define print-specific styles to ensure the label prints cleanly and compactly
        printWindow.document.write('<style>');
        printWindow.document.write(`
            @page { 
                margin: 3mm; /* Minimal margins for label printers */
            }
            body { 
                font-family: sans-serif; 
                display: block; 
                margin: 0;
                padding: 0;
            }
            .product-label-print-area {
                width: fit-content; /* Only take up necessary width */
                text-align: center;
                padding: 2mm; /* Small padding inside the print box */
                border: 1px solid white; 
            }
            .product-label-print-area svg { 
                height: 40px !important; 
                width: auto !important; 
                margin: 0 auto;
                display: block;
            }
            .product-label-print-area text { 
                font-size: 10px !important; 
            }
        `);
        printWindow.document.write('</style></head><body>');
        
        // Output the label content
        printWindow.document.write(content);
        
        printWindow.document.write('</body></html>');
        
        printWindow.document.close();
        printWindow.focus();
        
        // Give the browser a moment to render, then print
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 500);
    };

    if (!show) {
        return null;
    }

    const hasValidationErrors = Object.keys(errors).length > 0;

    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex justify-center items-center z-50 transition-opacity duration-300">
            <div className="relative bg-white p-8 rounded-lg shadow-xl w-11/12 max-w-6xl max-h-[90vh] overflow-y-auto transform scale-95 transition-transform duration-300" onClick={e => e.stopPropagation()}>
                <div className="flex justify-between items-center pb-4 mb-4 border-b border-gray-200">
                    <h2 className="text-2xl font-semibold text-gray-800">Manage Variants for {product.product_name}</h2>
                    <button className="text-gray-400 hover:text-gray-600 text-3xl leading-none font-semibold transition-colors duration-200" onClick={onClose}>
                        &times;
                    </button>
                </div>
                
                {loading ? (
                    <div className="text-center py-8">Loading variants...</div>
                ) : (
                    <div className="space-y-6">
                        <div className="flex items-center space-x-4">
                            <span className="text-sm font-medium text-gray-700">Product Status:</span>
                            <label className="relative inline-flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    checked={productStatus}
                                    onChange={(e) => setProductStatus(e.target.checked)}
                                    className="sr-only peer"
                                />
                                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                                <span className="ml-3 text-sm font-medium text-gray-900">{productStatus ? 'Active' : 'Inactive'}</span>
                            </label>
                        </div>

                        {variants.length > 0 ? (
                            <table className="min-w-full divide-y divide-gray-200 rounded-lg overflow-hidden border border-gray-200 shadow-sm">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Image</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">SKU</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Attributes</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Stock Qty</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">MRP</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sell Price</th>
                                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Label & Print</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {variants.map(variant => (
                                        <tr key={variant.product_item_id} className="hover:bg-gray-50">
                                            <td className="px-6 py-4 whitespace-nowrap cursor-pointer" onClick={() => handleImageClick(variant.product_item_images)}>
                                                {variant.product_item_images && variant.product_item_images.length > 0 && (
                                                    <img
                                                        // Access the 'main' property of the first object
                                                        src={`${BASE_URL}${variant.product_item_images[0].main}`}
                                                        alt={`Variant ${variant.product_item_id}`}
                                                        className="h-12 w-12 rounded-md object-cover border border-gray-200"
                                                    />
                                                )}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{variant.product_item_id}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {variant.size_name && `Size: ${variant.size_name}`}
                                                {variant.size_name && variant.color_name && " | "}
                                                {variant.color_name && `Color: ${variant.color_name}`}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                <input
                                                    type="number"
                                                    value={variant.product_item_stock_qty}
                                                    onChange={(e) => handleVariantChange(variant.product_item_id, 'product_item_stock_qty', e.target.value)}
                                                    className="w-20 rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                <input
                                                    type="number"
                                                    value={variant.product_item_mrp}
                                                    onChange={(e) => handleVariantChange(variant.product_item_id, 'product_item_mrp', e.target.value)}
                                                    className="w-20 rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                                />
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                <input
                                                    type="number"
                                                    value={variant.product_item_sell_price}
                                                    onChange={(e) => handleVariantChange(variant.product_item_id, 'product_item_sell_price', e.target.value)}
                                                    className={`w-20 rounded-md border-gray-300 shadow-sm focus:ring-blue-500 focus:border-blue-500 ${errors[variant.product_item_id]?.sell_price ? 'border-red-500' : ''}`}
                                                />
                                                {errors[variant.product_item_id]?.sell_price && (
                                                    <p className="text-red-500 text-xs mt-1">{errors[variant.product_item_id].sell_price}</p>
                                                )}
                                            </td>
                                            
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                <div id={`barcode-print-container-${variant.product_item_id}`} className="mb-2">
                                                    <ProductLabel 
                                                        variant={variant} 
                                                    />
                                                </div>
                                                {variant.barcode_number ? (
                                                    <button
                                                        onClick={() => handlePrintBarcode(variant)} 
                                                        className="mt-1 px-3 py-1 text-xs font-medium text-white bg-green-500 rounded-md hover:bg-green-600 transition-colors duration-150"
                                                    >
                                                        Print Label
                                                    </button>
                                                ) : (
                                                    <span className="text-xs text-red-500 italic">Missing barcode data</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <div className="text-center py-8 text-gray-500">No variants found for this product.</div>
                        )}
                        
                        <div className="flex justify-end pt-4 border-t border-gray-200">
                            <button
                                onClick={handleSave}
                                disabled={isSaving || hasValidationErrors}
                                className={`px-6 py-2 rounded-lg text-white font-semibold transition-colors duration-200 ${isSaving || hasValidationErrors ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
                            >
                                {isSaving ? 'Saving...' : 'Save Changes'}
                            </button>
                        </div>
                    </div>
                )}
            </div>
            
            {/* Assuming ImageCarouselModal is another component in your codebase */}
            <ImageCarouselModal show={showCarousel} onClose={() => setShowCarousel(false)} images={carouselImages} />
        </div>
    );
};


export default ProductVariantsModal